import { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';

const ALLOWED_FILE_TYPES = ['svg', 'raster'];

export default function MediaPreview({ srcUrl }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!srcUrl) return;

    let objectUrl = null;

    fetch(srcUrl)
      .then(async (res) => {
        if (!res.ok) throw new Error('Failed to fetch media file');

        const contentType = res.headers.get('content-type') || '';

        if (contentType.includes('image/svg+xml') || contentType.includes('application/octet-stream')) {
          const text = await res.text();
          setBlobUrl(`data:image/svg+xml;utf8,${encodeURIComponent(text)}`);
          setFileType('svg');
          return;
        }

        if (contentType.includes('image/png') || contentType.includes('image/jpeg') || contentType.includes('image/vnd.microsoft.icon')) {
          const blob = await res.blob();
          setBlobUrl(URL.createObjectURL(blob));
          setFileType('raster');
          return;
        }

        throw new Error('Media preview not supported for this file type');
      })
      .catch((err) => setError(err.message));
  }, [srcUrl]);

  return (
    <div className="media-preview normal">
      {error && <div>Error loading image: {error}</div>}
      {!blobUrl ||
        (!fileType && (
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ))}
      {blobUrl && fileType === 'svg' && <ReactSVG src={blobUrl} evalScripts="never" />}
      {blobUrl && fileType === 'raster' && <img src={blobUrl} alt="Preview" />}
      {blobUrl && !ALLOWED_FILE_TYPES.some((type) => type === fileType) && <div>Unsupported file type</div>}
    </div>
  );
}
